import { type ReactSelectOption } from '@/common/components/ReactSelect';

interface ToOptionsParameters {
  items: string[];
  suffix?: string;
}

const toOptions = ({ items, suffix }: ToOptionsParameters): ReactSelectOption[] =>
  items.map((item) => ({
    label: suffix ? `${item} ${suffix}` : item,
    value: item,
  }));

export default toOptions;
